/** The KPI strip shared by the dashboard and the intervenant workspace. */
export function Kpis({ items }: { items: [string, string][] }) {
  return (
    <div className="kpis">
      {items.map(([value, label]) => (
        <div className="kpi accent" key={label}>
          <div className="n">{value}</div>
          <div className="l">{label}</div>
        </div>
      ))}
    </div>
  );
}
